import { render, staticRenderFns } from "./riskFactor.vue?vue&type=template&id=6d1bab90&scoped=true&"
import script from "./riskFactor.vue?vue&type=script&lang=js&"
export * from "./riskFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1bab90",
  null
  
)

export default component.exports